import { ReactNode } from "react";
import {
  Table as TableBase,
  TableContainer,
  TableHead,
  TablePagination,
  TableBody,
} from "@mui/material";
import {
  TableColumn,
  OnPageChangeCb,
  OnRowSelectCb,
  onSortOrderChangeCb,
  onRowsPerPageChangeCb,
  TableRow as ITableRow,
  SortOrder,
} from "./Table.types";
import { TableHeader } from "./TableHeader";
import { TableRow } from "./TableRow";

export type TableProps = {
  rows: ITableRow[];
  columns: TableColumn[];
  page: number;
  orderByColumnId: string;
  rowsPerPage: number;
  sortOrder: SortOrder;
  selectedRow: ITableRow | undefined;
  totalRows: number;
  rowPerPagesOptions?: number[];
  sticky?: boolean;
  readonly?: boolean;
  displayBorder?: boolean;
  additionalTopHeader?: ReactNode;
  onRowSelect: OnRowSelectCb;
  onPageChange: OnPageChangeCb;
  onSortOrderChange: onSortOrderChangeCb;
  onRowsPerPageChange: onRowsPerPageChangeCb;
  isPaginationShown?: boolean;
  condensed?: boolean;
};

export const Table = ({
  rows,
  columns,
  rowsPerPage,
  totalRows,
  orderByColumnId,
  page,
  selectedRow,
  sortOrder,
  sticky,
  readonly = false,
  onRowSelect,
  onSortOrderChange,
  onRowsPerPageChange,
  onPageChange,
  additionalTopHeader,
  rowPerPagesOptions,
  displayBorder = false,
  isPaginationShown = true,
  condensed = true,
}: TableProps) => {
  return (
    <>
      <TableContainer
        sx={displayBorder ? { border: "1px solid #d0d0d0" } : {}}
        data-testid="table"
      >
        <TableBase stickyHeader={sticky} aria-label="sticky">
          <TableHead>
            {additionalTopHeader}
            <TableHeader
              columns={columns}
              sortOrder={sortOrder}
              orderByColumnId={orderByColumnId}
              onSortOrderChange={onSortOrderChange}
              condensed={condensed}
            />
          </TableHead>
          <TableBody>
            {rows?.map((row) => (
              <TableRow
                key={row.id}
                row={row}
                readonly={readonly}
                columns={columns}
                onRowSelect={onRowSelect}
                isSelected={row.id === selectedRow?.id}
                condensed={condensed}
              />
            ))}
          </TableBody>
        </TableBase>
      </TableContainer>
      {isPaginationShown && (
        <TablePagination
          page={page}
          count={totalRows}
          component="div"
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={rowPerPagesOptions}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </>
  );
};
